import React from 'react';
import ReportViewer from "./base/ReportViewer";

const QuotasPointsEau = () => {

    return (
        <div style={{height: "100%"}}>
            <ReportViewer reportName={"QuotasPointsEau"}/>
        </div>
    );
}
export default QuotasPointsEau;